// src/pages/OptOut.js

import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase'; // Verifique se o caminho está correto

const OptOut = () => {
  const [searchParams] = useSearchParams();
  const cnpj = searchParams.get('cnpj');
  const [status, setStatus] = useState('Processando sua solicitação...');

  useEffect(() => {
    const processarOptOut = async () => {
      if (!cnpj) {
        setStatus('Link inválido ou CNPJ não fornecido.');
        return;
      }

      try {
        const registrarOptOut = httpsCallable(functions, 'registrarOptOutB2B');
        await registrarOptOut({ cnpj });
        setStatus('Seu e-mail foi removido da nossa lista com sucesso. Você não receberá mais comunicações deste tipo.');
      } catch (error) {
        console.error("Erro no Opt-out:", error);
        setStatus('Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente mais tarde.');
      }
    };

    processarOptOut();
  }, [cnpj]);

  return (
    <div style={{ padding: '60px 20px', textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ maxWidth: '600px', backgroundColor: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
        <h1 style={{ color: '#0369a1', marginBottom: '20px' }}>Descadastramento (Opt-out)</h1>
        <p style={{ fontSize: '1.2rem', color: '#475569', marginBottom: '30px' }}>
          {status}
        </p>
        <Link to="/" style={{ color: '#0ea5e9', textDecoration: 'none', fontWeight: 'bold' }}>
          Voltar para a Página Inicial
        </Link>
      </div>
    </div>
  );
};

export default OptOut;